import { AlertCircle, CheckCircle2, Info, TriangleAlert } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

type Tone = 'danger' | 'warning' | 'info' | 'success'

const styles: Record<Tone, string> = {
  danger: 'bg-danger-soft text-danger',
  warning: 'bg-warning-soft text-warning',
  info: 'bg-info-soft text-info',
  success: 'bg-success-soft text-success',
}
const icons = { danger: AlertCircle, warning: TriangleAlert, info: Info, success: CheckCircle2 }

export function InlineAlert({
  tone = 'info',
  title,
  children,
  action,
  className,
}: {
  tone?: Tone
  title?: ReactNode
  children?: ReactNode
  action?: ReactNode
  className?: string
}) {
  const Icon = icons[tone]
  return (
    <div role={tone === 'danger' ? 'alert' : 'status'} className={cn('flex gap-2.5 rounded-[calc(12px*var(--radius-scale))] px-[calc(var(--spacing)*3.5*var(--ui-size))] py-[calc(var(--spacing)*3*var(--ui-size))] text-[length:calc(13px*var(--text-scale)*var(--ui-size))]', styles[tone], className)}>
      <Icon className="mt-px size-4 shrink-0" aria-hidden />
      <div className="min-w-0 flex-1">
        {title && <p className="font-medium">{title}</p>}
        {children && <div className={cn(title && 'mt-0.5', 'text-fg-2')}>{children}</div>}
      </div>
      {action}
    </div>
  )
}
